import userTypes from "./user.types"

export const setLoginStatus = status => {
    return {
        type: userTypes.LOGIN_STATUS,
        payload: status
    }
}
